import React from 'react';
import {AddressItemProps} from "../../../../@types/address";

const AddressItem: React.FC<AddressItemProps> = ({ address, onSelect }) => {

    return (
      <div className="flex items-center space-x-4" onClick={() => onSelect(address)}>
        <div className="flex-shrink-0">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" className="w-10 h-10 text-fred-blue-500">
            <path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
            <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z" />
          </svg>
        </div>
        <div className="flex-1 min-w-0">
            <p className="text-xl font-medium">
              {address.fullAddress}
            </p>
            <p className="text-base text-gray-400">
              {address.subAddress}
            </p>
        </div>
      </div>
    );
  };

export default AddressItem;
